export const GENDER = [
    { 'id': 'a', 'name': 'All' },
    { 'id': 'm', 'name': 'Male' },
    { 'id': 'f', 'name': 'Female' },
    { 'id': 'o', 'name': 'Others' }
]

export const CAN_GENDER = [
    { 'id': 'm', 'name': 'Male' },
    { 'id': 'f', 'name': 'Female' },
    { 'id': 'o', 'name': 'Others' }
]

export const EXPERIENCE = [
    { 'id': 1, 'name': '1 Years' },
    { 'id': 2, 'name': '2 Years' },
    { 'id': 3, 'name': '3 Years' },
    { 'id': 4, 'name': '4 Years' },
    { 'id': 5, 'name': '5 Years' }
]

export const SALARY_AMT_TYPE = [
    { 'id': 'h', 'name': 'Hour' },
    { 'id': 'd', 'name': 'Day' },
    { 'id': 'm', 'name': 'Month' },
    { 'id': 'y', 'name': 'Annum' }
]

export const SALARY_AMT_TYPE_VIEW = {
    'h': 'Hour',
    'd': 'Day',
    'm': 'Month',
    'y': 'Annum'
}

export const APPLY_JOB_STATUS = {
    'a': 'Applied',
    's': 'Saved',
    'r': 'Rejected',
    'p': 'Pending',
    'h': 'Hired'
}

export const CAN_TYPES = [
    { 'id': '1', 'name': 'Student' },
    { 'id': '2', 'name': 'Alumni' },
    { 'id': '3', 'name': 'General' }
]